var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwardCabinetViewEntries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "award_cabinet_view_entries") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.23,
    y: -0.38,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "award_cabinet_view_entries"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.33,1.21a17,17,0,0,0-17,16.88V428.93a17,17,0,0,0,17,16.88H582.21a17,17,0,0,0,17-16.88V18.09a17,17,0,0,0-17-16.88",
    fill: "#ff4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 77.36,
    width: 380.92,
    height: 444.6,
    rx: 16.79,
    fill: "#ff9f92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.42,271.42V583.17a17,17,0,0,1-17.25,16.71H17.76C8.23,599.88.5,592.41.5,583.17V172c0-9.23,7.73-16.71,17.26-16.71H261.55a17.9,17.9,0,0,1,5.84,1L379.87,264.5A16.13,16.13,0,0,1,381.42,271.42Z",
    fill: "#ffdcd7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.66,263.49h-95a17.21,17.21,0,0,1-17.44-17V155.27Z",
    fill: "#ff4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.92,
    y: 371.97,
    width: 262.23,
    height: 36.28,
    rx: 12,
    transform: "translate(-2.94 1.41) rotate(-0.43)",
    fill: "#ff4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.03,
    y: 517.55,
    width: 133.73,
    height: 36.28,
    rx: 12,
    transform: "translate(-4.04 0.94) rotate(-0.43)",
    fill: "#ff4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.36,
    y: 299.41,
    width: 262.23,
    height: 36.28,
    rx: 12,
    transform: "translate(-2.39 1.41) rotate(-0.43)",
    fill: "#ff4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.47,
    y: 444.52,
    width: 261.46,
    height: 36.28,
    rx: 12,
    transform: "translate(-3.49 1.42) rotate(-0.43)",
    fill: "#ff4a4a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardCabinetViewEntries);
export default __webpack_public_path__ + "static/media/award_cabinet_view_entries.2b98407ab1027b8781ecd36c7d059882.svg";
export { ForwardRef as ReactComponent };